import { create } from 'zustand';
import type { GameState, TeamId, ClientRole } from '../types/game';

const DEFAULT_STATE: GameState = {
  status: 'idle',
  grade: '1',
  round: 1,
  currentQuestion: null,
  currentSubject: null,
  winner: null,
  buzzer: 'closed',
  blockedTeams: [],
  attemptedTeams: [],
  scores: { A: 0, B: 0, C: 0 },
  timerExpiresAt: null,
  subjects: [],
  gameId: '',
  roundPhase: 'roulette',
  teamOrder: [],
  teamQueue: [],
  usedSubjects: [],
  currentTurnIndex: 0,
  buzzerActive: false,
  stealWindow: false,
  firstTurnTeam: null,
  questionsThisRound: 0,
};

interface GameStore {
  // Game state from server
  game: GameState;
  // Clock offset: serverNow - clientNow, updated on every STATE_SYNC
  clockOffset: number;
  // Connection info
  connected: boolean;
  connectionStatus: 'disconnected' | 'connecting' | 'connected' | 'error';
  // Local client info
  gameId: string;
  team: TeamId | null;
  role: ClientRole;
  // Flash messages
  lastEvent: { type: string; message: string; ts: number } | null;
  // Actions
  setGame: (state: GameState) => void;
  setConnected: (v: boolean) => void;
  setConnectionStatus: (s: GameStore['connectionStatus']) => void;
  setClientInfo: (gameId: string, team: TeamId | null, role: ClientRole) => void;
  setLastEvent: (type: string, message: string) => void;
}

export const useGameStore = create<GameStore>((set) => ({
  game: DEFAULT_STATE,
  clockOffset: 0,
  connected: false,
  connectionStatus: 'disconnected',
  gameId: '',
  team: null,
  role: 'projector',
  lastEvent: null,

  setGame: (state) => set((prev) => ({
    game: state,
    clockOffset: state.serverNow != null ? state.serverNow - Date.now() : prev.clockOffset,
  })),
  setConnected: (v) => set({ connected: v }),
  setConnectionStatus: (s) => set({ connectionStatus: s }),
  setClientInfo: (gameId, team, role) => set({ gameId, team, role }),
  setLastEvent: (type, message) => set({ lastEvent: { type, message, ts: Date.now() } }),
}));
